<template>
  <div class="contact-lenses-meta-dropdown">
    <div class="lens-column contact-lenses-checkbox">
      <label>
        <input type="checkbox" class="column-header" v-model="lensSelection.left" @change="handleCheckboxChange('left')">
        {{ t('left.lens') }}
      </label>
      <div v-for="(values, category) in metadata" :key="'left-' + category" class="lens-container">
        <div class="contact-lenses-meta-dropdown__label">
          <label>{{ category }}</label>
          <button data-tooltip-anchor="top" :data-tooltip="getTooltipText(category)" class="tooltip-button">
            <img src="/ui/main/img/tooltip.svg" alt="Tooltip icon" />
          </button>
        </div>
        <div class="contact-lenses-meta-dropdown__select">
          <CustomSelect
            :options="values"
            :defaultValue="values[27]"
            v-model="selectedValues.left[category]"
            :disabled="!lensSelection.left"
            @change="emitSelectedValues('left')">
          </CustomSelect>
        </div>
      </div>
    </div>
    <div class="lens-column contact-lenses-checkbox">
      <label>
        <input type="checkbox" class="column-header" v-model="lensSelection.right" @change="handleCheckboxChange('right')">
        {{ t('right.lens') }} {{ showExtraCost ? '+' + productPrice[0] : '' }}
        <span v-show="showExtraCost" v-html="productPrice[1]"></span>
      </label>
      <div v-for="(values, category) in metadata" :key="'right-' + category" class="lens-container">
        <div class="contact-lenses-meta-dropdown__label">
          <label>{{ category }}</label>
          <button data-tooltip-anchor="top" :data-tooltip="getTooltipText(category)" class="tooltip-button">
            <img src="/ui/main/img/tooltip.svg" alt="Tooltip icon" />
          </button>
        </div>
        <div class="contact-lenses-meta-dropdown__select">
          <CustomSelect
            :options="values"
            :defaultValue="values[27]"
            v-model="selectedValues.right[category]"
            :disabled="!lensSelection.right"
            @change="emitSelectedValues('right')">
          </CustomSelect>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomSelect from './CustomSelect.vue'
import { computed, ref } from 'vue'
import useLocalization from '../composables/useLocalization'

export default {
  name: 'ContactLensesMetaDropdown',
  components: {
    CustomSelect
  },
  setup(props, { emit }) {
    const selectedValues = ref({
      left: {},
      right: {}
    })

    const lensSelection = ref({
      left: true,
      right: false
    })

    for (const category in props.metadata) {
      if (props.metadata.hasOwnProperty(category)) {
        selectedValues.value.left[category] = props.metadata[category][0]
        selectedValues.value.right[category] = props.metadata[category][0]
      }
    }

    function emitSelectedValues (eye) {
      const selectedEyeValues = selectedValues.value[eye]
      emit('selected', { eye, values: selectedEyeValues })
    }
    function emitEditableDropdown(eye, value) {
      emit('active-field', { eye, value })
    }

    function getTooltipText (category) {
      switch (category) {
        case 'sph':
          return t('lenses.product.meta.data.tooltip.sph')
        case 'cyl':
          return t('lenses.product.meta.data.tooltip.cyl')
        case 'axis':
          return t('lenses.product.meta.data.tooltip.axis')
        case 'addition':
          return t('lenses.product.meta.data.tooltip.addition')
      }
    }

    function handleCheckboxChange (eye) {
      if (!lensSelection.value[eye]) {
        selectedValues.value[eye] = {}
      }
      emitEditableDropdown(eye, lensSelection.value[eye])
      emitSelectedValues(eye)
    }
    const { t } = useLocalization()

    const showExtraCost = computed(() => {
      return lensSelection.value.left && lensSelection.value.right
    })

    emitEditableDropdown('left', lensSelection.value.left)
    emitSelectedValues('left', selectedValues.value.left)
    return {
      selectedValues,
      lensSelection,
      metadata: props.metadata,
      emitSelectedValues,
      emitEditableDropdown,
      getTooltipText,
      handleCheckboxChange,
      t,
      showExtraCost
    }
  },
  props: {
    metadata: {
      type: Object,
      required: true
    },
    productPrice: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.contact-lenses-meta-dropdown {
  width: 100%;
  display: grid;
  grid-template-columns: 45% 45%;
  justify-items: center;
  grid-gap: 10%;
  justify-content: space-evenly;
  margin-bottom: 1rem;
  z-index: 10;
}
.lens-column {
  width: 100%;
  position: relative;
  label {
    position: relative;
  }

  .column-header {
    margin-right: 5px;
  }

  > label:before {
    content: "";
    display: inline-block;
    width: 16px;
    height: 16px;
    position: absolute;
    margin-right: 10px;
    left: 0;
    bottom: 7px;
    background-color: #fff;
    box-shadow: rgba(255, 255, 255, 0.2) 0 0 0 1px inset, rgba(0, 0, 0, 0.9) 0 0 0 1px;
    border-radius: 2px;
  }

  .contact-lenses-checkbox label:before {
    border-radius: 3px;
  }

  label:has(> input[type=checkbox]:checked) > input[type=checkbox]::after {
    content: "\2713";
    background-color: black;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, .2);
    font-size: 12px;
    color: #ffc800;
    text-align: center;
    line-height: 16px;
    position: absolute;
    width: 16px;
    height: 16px;
  }

}
.column-header {
  font-weight: bold;
  margin-bottom: 10px;
}
.lens-container {
  margin-bottom: 10px;
}
select {
  width: 90%;
  height: 40px;
  border-radius: 12px;
  background: #F6F6F6 0 0 no-repeat padding-box;
  border: 1px solid #DBDBDB;
}

[data-tooltip] {
  display: inline-block;
  position: relative;
  z-index: 3;
  --carat-size: 15px;
  --offset: 0.5rem;

  --tooltip-position: calc(100% + var(--offset));
  --carat-position: calc(100% + var(--offset) - var(--carat-size) / 2);

  &::before,
  &::after {
    opacity: 0;
    pointer-events: none;
    display: block;
    position: absolute;
    transition: opacity 0.15s ease-out;
  }

  &::before {
    content: "";
    background-color: #F6F6F6;
    height: var(--carat-size);
    width: var(--carat-size);
    border: 1px solid #DBDBDB;
    opacity: 0;
  }

  &::after {
    content: attr(data-tooltip);
    color: #000;
    background-color: #F6F6F6;
    border-radius: 8px;
    min-width: 15vw;
    text-align: left;
    z-index: 10;
    opacity: 0;
    padding: 1rem;
    border: 1px solid #DBDBDB;
  }

  &:hover::before,
  &:hover::after,
  &:focus-within::before,
  &:focus-within::after {
    display: block;
    opacity: 1;
    pointer-events: unset;
  }

  &[data-tooltip-anchor="top"]::before {
    bottom: var(--carat-position);
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
  }

  &[data-tooltip-anchor="top"]::after {
    bottom: var(--tooltip-position);
    left: 50%;
    transform: translateX(-50%);
  }
}

.tooltip-button {
  background: none;
  border: none;
  margin-bottom: 5px;
}

.contact-lenses-meta-dropdown__label {
  label {
    text-transform: uppercase;
  }
}
</style>
